import { FormErrors, useForm as mantineUseForm } from '@mantine/form';

/**
 * A local copy of `@hooks/useFormWithNameInputProp`, deliberately duplicated rather than imported.
 *
 * `useFormPolicy` is the framework's one Mantine-integration point (the pure resolution engine -
 * `createFieldPolicy`, `createPolicyField`, `policyScope` - stays form-library-agnostic on purpose).
 * Depending on the shared app-wide hook would mean an unrelated change to it could alter the
 * framework's own form behavior without anyone touching `field-policy/` at all. Keeping this copy
 * here means the framework's Mantine integration only ever changes when this file does.
 */
interface FormOptions<T> {
  initialValues: T;
  validate?: (values: T) => FormErrors;
  validateInputOnBlur?: boolean;
  validateInputOnChange?: boolean;
}

export const useFormWithNameInputProp = <T>(options: FormOptions<T>) => {
  const form = mantineUseForm({ ...options });

  // Wrap the original getInputProps to always include the `name` prop
  const getInputProps = (name, inputProps = {}) => {
    return {
      name,
      ...form.getInputProps(name, inputProps),
    };
  };

  return {
    ...form,
    getInputProps,
  };
};
